import { baseApi } from "./base.api";

export const socialLinksApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchSocialLinks: build.query({
      query: (params) => ({ url: "/social-links/fetch", method: "GET", params }),
      providesTags: ["SocialLink"],
    }),
    fetchSocialLinksAll: build.query({
      query: () => ({ url: "/social-links/fetch/all", method: "GET" }),
      providesTags: ["SocialLink"],
    }),
    fetchTrashedSocialLinks: build.query({
      query: (params) => ({ url: "/social-links/fetch/trashed", method: "GET", params }),
      providesTags: ["SocialLink"],
    }),
    fetchSocialLinkById: build.query({
      query: (id) => ({ url: `/social-links/fetch/${id}`, method: "GET" }),
      providesTags: ["SocialLink"],
    }),
    createSocialLink: build.mutation({
      query: (body) => ({ url: "/social-links/create", method: "POST", body }),
      invalidatesTags: ["SocialLink"],
    }),
    updateSocialLink: build.mutation({
      query: ({ id, body }) => ({ url: `/social-links/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["SocialLink"],
    }),
    changeSocialLinkStatus: build.mutation({
      query: (id) => ({ url: `/social-links/status/${id}`, method: "PUT" }),
      invalidatesTags: ["SocialLink"],
    }),
    restoreSocialLink: build.mutation({
      query: (id) => ({ url: `/social-links/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["SocialLink"],
    }),
    bulkRestoreSocialLinks: build.mutation({
      query: (body) => ({ url: "/social-links/bulk-restore", method: "POST", body }),
      invalidatesTags: ["SocialLink"],
    }),
    deleteSocialLink: build.mutation({
      query: (id) => ({ url: `/social-links/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["SocialLink"],
    }),
    bulkDeleteSocialLinks: build.mutation({
      query: (body) => ({ url: "/social-links/bulk-delete", method: "POST", body }),
      invalidatesTags: ["SocialLink"],
    }),
    destroySocialLink: build.mutation({
      query: (id) => ({ url: `/social-links/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["SocialLink"],
    }),
    bulkDestroySocialLinks: build.mutation({
      query: (body) => ({ url: "/social-links/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["SocialLink"],
    }),
  }),
});

export const {
  useFetchSocialLinksQuery,
  useFetchSocialLinksAllQuery,
  useFetchTrashedSocialLinksQuery,
  useFetchSocialLinkByIdQuery,
  useCreateSocialLinkMutation,
  useUpdateSocialLinkMutation,
  useChangeSocialLinkStatusMutation,
  useRestoreSocialLinkMutation,
  useBulkRestoreSocialLinksMutation,
  useDeleteSocialLinkMutation,
  useBulkDeleteSocialLinksMutation,
  useDestroySocialLinkMutation,
  useBulkDestroySocialLinksMutation,
} = socialLinksApi;
